/** Stable Table rowKey for tariff line items — never use Math.random() (breaks row selection). */
export function getTariffItemRowKey(record, index) {
  const id =
    record?.id ??
    record?.facility_tariff_item_id ??
    record?.item_id ??
    record?.tariff_item_id ??
    record?.standardized_item_id;
  return id != null && id !== '' ? String(id) : `tariff-item-${index}`;
}

/** Stable Table rowKey for tariff list rows. */
export function getTariffListRowKey(record, index) {
  const id =
    record?.id ??
    record?.tariff_id ??
    record?.facility_tariff_id ??
    record?.uuid;
  return id != null && id !== '' ? String(id) : `tariff-${index}`;
}
